import React from 'react';
import BackButton from '../components/BackButton';
import TheThreeQuestions from '../components/TheThreeQuestions';

function TheThreeQuestionsPage() {
  return (
    <>
      <BackButton />
      <TheThreeQuestions />
    </>
  );
}

export default TheThreeQuestionsPage;
